import { Injector } from "@angular/core";
import { ResultList } from "../../ListEntity/ResultList";
import { OutBoxListView } from "../../../Data/WebTraderData/OutboxListView";
import { Art57Section } from "../../../Art57Section/Art57Section";
import { BaseNode } from "../../BaseNode";
import { QueryNodeOutBox } from "../Query/QueryNodeOutBox";
import { EntityEnum } from "../../EntityEnum";
import { PaginationControl } from "../../../PaginationControl";
import { WebTraderQueryResultNode } from "../WebTraderQueryResultNode";
import { DateUtil } from "../../../DateUtil";
import { Art57NodeUtils } from "../../Art57Node/Art57NodeUtils";
import { QueryConditionNodeOutbox } from "../Query/QueryConditionNodeOutbox";

export class ResultListNodeOutbox extends ResultList {

    constructor(injector: Injector) {
        super(injector);
    }

    override addResult(requestedNode: BaseNode, itemPagination: PaginationControl, data: any, parentNode: BaseNode): BaseNode | null {
        const listViewData = new OutBoxListView(data);
        let resultNodeOutbox = null;
        const selectedNode = requestedNode;
        if (selectedNode instanceof QueryNodeOutBox || selectedNode instanceof WebTraderQueryResultNode) {
            selectedNode.data = listViewData;
        } else {
            const conditionsNode = Art57NodeUtils.findChildNodeOfType(this.parent!.children as BaseNode[], QueryConditionNodeOutbox) as QueryConditionNodeOutbox;
            resultNodeOutbox = new WebTraderQueryResultNode(this.ioc!, listViewData, "Result " + DateUtil.getResultDateTime(), EntityEnum.oub, null, conditionsNode, []);
            resultNodeOutbox.paginationControl = itemPagination;
            if (data.length > 0) {
                if (!(this.ioc!.get(Art57Section).getSelectedSection().selectedNode instanceof QueryNodeOutBox)) {
                    resultNodeOutbox.parent = parentNode;
                    this.children?.push(resultNodeOutbox);
                } else {
                    resultNodeOutbox.parent = requestedNode;
                }
            }
        }

        return resultNodeOutbox;
    }
}